import colors from 'src/integration/styles/colors';
import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface ComponentProps extends Component {
  children: ReactNode;
  level?: 'b1-reg' | 'b1-med' | 'b2-reg' | 'b2-med' | 'b3-reg' | 'b3-med';
  color?: string;
}

const Body = styled.p<{$color?: string}>`
  ${({$color}) => css`
    color: ${$color ? $color : colors.primaryDarkJungleGreen};
    font-style: normal;
    line-height: 130%;
  `}
`;

const Body1Regular = styled(Body)`
  ${() => css`
    font-size: 16px;
    font-weight: 400;
  `}
`;

const Body1Medium = styled(Body)`
  ${() => css`
    font-size: 16px;
    font-weight: 500;
  `}
`;

const Body2Regular = styled(Body)`
  ${() => css`
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
  `}
`;

const Body2Medium = styled(Body)`
  ${() => css`
    font-size: 14px;
    font-weight: 500;
  `}
`;

const Body3Regular = styled(Body)`
  ${() => css`
    font-size: 12px;
    font-weight: 400;
  `}
`;

const Body3Medium = styled(Body)`
  ${() => css`
    font-size: 12px;
    font-weight: 500;
  `}
`;

const BodyText = ({ children, level, color, className }: ComponentProps) => {
  if (level === 'b1-med') {
    return <Body1Medium className={className} $color={color}>{children}</Body1Medium>;
  }

  if (level === 'b2-reg') {
    return <Body2Regular className={className} $color={color}>{children}</Body2Regular>;
  }

  if (level === 'b2-med') {
    return <Body2Medium className={className} $color={color}>{children}</Body2Medium>;
  }

  if (level === 'b3-reg') {
    return <Body3Regular className={className} $color={color}>{children}</Body3Regular>;
  }

  if (level === 'b3-med') {
    return <Body3Medium className={className} $color={color}>{children}</Body3Medium>;
  }

  return <Body1Regular className={className} $color={color}>{children}</Body1Regular>;
};

export default BodyText;
